export default __webpack_public_path__ + "static/chrome_logo-be1ed25cc23eefc752352585021f727f.svg";